// extracted by mini-css-extract-plugin
module.exports = {"userReportLayout":"_3n-mS"};